<script lang="ts">
  import { getContext } from 'svelte';
  import type { PlayerStateContext } from '../../shared/types/player-state';

  const { poster, headline, secondaryHeadline } = getContext<PlayerStateContext>('playerState');
</script>

{#if $poster || $headline || $secondaryHeadline}
  <div class="medium-info">
    {#if $poster}
      <img src={$poster} alt="" class="poster" />
    {/if}

    {#if $headline || $secondaryHeadline}
      <div class="content">
        {#if $secondaryHeadline}
          <p class="secondary-headline">{$secondaryHeadline}</p>
        {/if}
        {#if $headline}
          <p class="headline">{$headline}</p>
        {/if}
      </div>
    {/if}
  </div>
{/if}

<style module>
  .medium-info {
    display: flex;
    gap: 1em;
  }

  .poster {
    width: 68px;
    height: 68px;
    object-fit: cover;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    word-break: break-word;
  }

  .secondary-headline {
    margin: 0;
    font-size: 0.75em;
    font-size: clamp(0.75em, 1cqw + 0.5em, 1em);
  }

  .headline {
    margin: 0;
    line-height: 1.5;
    font-weight: bold;
    font-size: 1.125em;
    font-size: clamp(0.875em, 1cqw + 0.625em, 1.125em);
  }
</style>
